export default {
  "name": "NCInsertTable",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCInsertTable",
  "label": "树状表格",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "组件标识",
        "type": "string"
      },
      "headTableId": {
        "title": "主表区域编码",
        "description": "主表区域编码",
        "type": "string"
      },
      "bodyTableId": {
        "title": "子表区域编码",
        "description": "子表区域编码",
        "type": "string"
      },
      "comType": {
        "title": "是否需要复选框",
        "description": "是否需要复选框",
        "enumNames": [
          "normal",
          "hasCheckBox",
          "hasCheckBox_child"
        ],
        "type": "enum",
        "enum": [
          "normal",
          "hasCheckBox",
          "hasCheckBox_child"
        ]
      },
      "isDrag": {
        "title": "是否可拖拽",
        "description": "是否可拖拽",
        "type": "boolean",
        "default": true
      },
      "needIndex": {
        "title": "是否显示序号列",
        "description": "是否显示序号列",
        "type": "boolean",
        "default": true
      },
      "adaptionHeight": {
        "title": "是否自适应高度",
        "description": "是否自适应高度",
        "type": "boolean",
        "default": false
      },
      "otherAreaHeight": {
        "title": "其他区域高度",
        "description": "其他区域高度",
        "type": "number"
      },
      "multipleRowCell": {
        "title": "是否显示多行",
        "description": "是否显示多行",
        "type": "boolean",
        "default": false
      },
      "inModal": {
        "title": "是否在弹窗内",
        "description": "是否在弹窗内",
        "type": "boolean",
        "default": false
      },
      "insertTableHeight": {
        "title": "表格高度",
        "description": "表格高度",
        "type": "number"
      },
      "visible": {
        "title": "是否可见",
        "description": "是否可见",
        "type": "boolean"
      }
    },
    "required": [
      "moduleId",
      "headTableId",
      "bodyTableId"
    ]
  },
  "uiSchema": {},
  "slots": []
}